import { useState } from "react";
import { LogOut, Settings } from "lucide-react";
import { Button } from "@pix2bit/ui/components";
import { UserLogoutMutation } from "./UserLogoutMutation";
import { useAuthState } from "../context/AuthContext";
import { useMutationCallbacks } from "../../utils/graphql/useMutationCallbacks";

export const SettingsDropdown = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { logout } = useAuthState();

  const [logoutUser, isPending] = useMutationCallbacks({
    mutation: UserLogoutMutation,
    name: "UserLogout",
    afterCompleted: (response) => {
      if (response.UserLogout?.success && !response.UserLogout?.error) {
        setTimeout(() => {
          logout();
        }, 100);
      }
    },
  });

  const handleLogout = () => {
    if (isPending) return;

    logoutUser({
      variables: {
        input: {},
      },
    });
  };

  return (
    <div className="relative">
      <Button
        variant="ghost"
        size="icon"
        onClick={() => setIsOpen(!isOpen)}
        className="focus:outline-none"
      >
        <Settings className="h-4 w-4" />
      </Button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-48 bg-white border border-gray-200 rounded-md shadow-lg z-50">
          <div className="py-1">
            <button
              onClick={handleLogout}
              disabled={isPending}
              className="flex items-center w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isPending ? (
                <>
                  <div className="w-4 h-4 border-2 border-gray-400 border-t-transparent rounded-full animate-spin mr-2" />
                  Logging out...
                </>
              ) : (
                <>
                  <LogOut className="h-4 w-4 mr-2" />
                  Logout
                </>
              )}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};